/*
 * @Description: API for sales channel currency
 */
import { get } from 'src/tools/server';

export const getCurrencyList = (salesChannelUuid: string) => {
  return get<any[]>(`/portal/currency/salesChannel/${salesChannelUuid}`, {});
};
